import styled from 'styled-components';

export const DecoratorCSS = styled.div`
  background: var(--primary);
  width: 100%;
  height: 85px;
`;